module.exports = __webpack_public_path__ + "img/home-1.0bb5719c.png";